import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import deleteWork from "astrid-firestore/src/api/works/deleteWork";

import { useProfile } from "../../../../authentication/state/profile";

export default function useWorkDropdownMenuOptions({ work }) {
	const user = useProfile();

	const { t } = useTranslation();

	return [
		{
			text: t("delete", "Delete"),
			confirmText: t("deleteWorkConfirmation", "Do you want to delete this work and all its articles?"),
			action: () => deleteWork(firebase, { work, user }),
		},
	];
}
